const reducer = (state = {}, action) =>{
    switch(action.type){
        case "setFooterConfig": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  